module.exports = __webpack_public_path__ + "static/img/ygq.ecae786e.png";